<template>
  <transition name="tabset-slide">
    <div
      ref="tabEl"
      class="tabset__pane"
      :class="{ 'tabset__pane--active': active }"
      role="tabpanel"
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import { inject, onMounted, ref, computed } from "vue";

export default {
  props: {
    header: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const registerTab = inject("registerTab", null);
    const active = ref(false);
    const tabEl = ref(null);

    const href = computed(() => `#${props.header.toLowerCase().replace(/ /g, '-')}`);

    onMounted(() => {
      if (registerTab) {
        registerTab({
          header: props.header,
          href: href.value,
          active,
          el: tabEl
        });
      }
    });

    return {
      active,
      href,
      tabEl
    };
  }
};
</script>
